import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface RouteManagementStates {
  startCooApplication: boolean,
  startAddressSelection: boolean,
  startStageD: boolean,
  startStageE: boolean,
}

const initialState: RouteManagementStates = {
  startCooApplication: false,
  startAddressSelection: false,
  startStageD: false,
  startStageE: false
};


const RouteManagementSlice = createSlice({
  name:"Routes Managements Slice",
  initialState,
  reducers:{
    openRouteStartCooApplication: (state, action: PayloadAction<boolean>) => {
      state.startCooApplication = action.payload;
    },
    openRouteAddressSelection: (state, action: PayloadAction<boolean>) => {
      state.startAddressSelection = action.payload;
    },
    openRouteStageD: (state, action: PayloadAction<boolean>) => {
      state.startStageD = action.payload;
    },
    openRouteStageE: (state, action: PayloadAction<boolean>) => {
      state.startStageE = action.payload;
    },
    resetRoutes:(state) => {
      state.startCooApplication = false;
      state.startAddressSelection = false;
      state.startStageD = false;
    }
  },
  extraReducers: (builder) => {}
});


export const { openRouteStartCooApplication, openRouteAddressSelection, openRouteStageD, resetRoutes, openRouteStageE } = RouteManagementSlice.actions;

export default RouteManagementSlice.reducer;


